import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue';
import AboutUs from '../views/user/AboutUs.vue';
import UserLogin from '@/views/user/UserLogin.vue';
import AccountRegister from '@/views/user/AccountRegister.vue';
import ProfilePage from '@/views/user/ProfilePage.vue';
import PropertiePage from '@/views/Properties/PropertiePage.vue';
import PropertyDetails from '@/views/Properties/PropertyDetails.vue';
import PropertyPerview from '@/views/Properties/PropertyPerview.vue';
// import PropertieCreate from '@/views/Properties/PropertieCreate.vue';
import AdvertisementsView from '@/views/AdvertisementsView.vue';
import PropertyManagement from '@/views/Properties/PropertyManagement.vue';
import PropertieList from '@/views/Properties/PropertieList.vue';
import CitiesList from '@/views/Properties/CitiesList.vue';
import PropertieUpdate from '@/views/Properties/PropertieUpdate.vue';
import NearProperties from '@/views/Properties/NearProperties.vue';
import WalletPage from '@/views/user/WalletPage.vue';
import AddCard from '@/views/paymentcard/AddCard.vue';
import PaymentCards from '@/views/paymentcard/PaymentCards.vue';
import PreviewList from '@/views/Properties/PreviewList.vue';
import PreviewDetails from '@/views/Properties/PreviewDetails.vue';
import MyReservations from '@/views/reservations/MyReservations.vue';
import PropertyReservation from '@/views/reservations/PropertyReservation.vue';
import PropertyRequest from '@/views/Properties/PropertyRequest.vue';
import QuestionsPage from '@/views/user/QuestionsPage.vue';
import FavoriteProperties from "@/views/Properties/FavoriteProperties.vue";
import MaintenanceRequest from "@/views/maintenance/MaintenanceRequest.vue";
import MaintenanceDetails from "@/views/maintenance/MaintenanceDetails.vue";
import MaintenancePage from "@/views/maintenance/MaintenancePage.vue";
import MapsPage from "@/views/user/MapsPage.vue";
import BlogForm from "@/views/user/BlogForm.vue";
import BlogDetails from "@/views/user/BlogDetails.vue";
import SettingsPage from "@/views/user/SettingsPage.vue";
import ForgetPassword from "@/views/user/ForgetPassword.vue";
import RentalRetrieve from "@/views/user/RentalRetrieve.vue";
import TermsConditions from "@/views/user/TermsConditions.vue";
import FinancialTransactions from "@/views/financialTransactions/FinancialTransactions.vue";
import SuccessPage from '@/views/paymentcard/SuccessPage.vue';
import FailedPage from '@/views/paymentcard/FailedPage.vue';
import PaymentFailed from '@/views/paymentcard/PaymentFailed.vue';
import PaymentSuccess from '@/views/paymentcard/PaymentSuccess.vue';
import MyProperty from  '@/views/user/MyProperty.vue';
import MyRents from  '@/views/user/MyRents.vue';
import MybankAccount from  '@/views/user/MybankAccount.vue';
import Page404 from '@/views/user/Page404.vue';
import CreateFinance from '@/views/Finance_Requests/CreateFinance.vue';
import MyRequests from '@/views/user/MyRequests.vue';
import MaintenancesList from '@/views/maintenance/MaintenancesList.vue';
import BusinessProject from "@/views/Business_Transfer/BusinessProject.vue";
import professionalPhotography from '@/views/user/professionalPhotography.vue';
import photographyDetails from '@/views/user/photographyDetails.vue';
import lawyerRequested from '@/views/user/ lawyerRequested.vue';
import BusinessTransferList from '@/views/Business_Transfer/BusinessTransferList.vue';
import Business_TransferDetails from "@/views/Business_Transfer/Business_TransferDetails.vue";
import lawyerRequestedDetails from "@/views/user/lawyerRequestedDetails.vue";
import AdvertismentReport from "@/views/user/AdvertismentReport.vue";
import PropReservationDetails from "@/views/reservations/PropReservationDetails.vue";
import PrivacyPolicy from "@/views/user/PrivacyPolicy.vue";
import Complaints from "@/views/user/Complaints.vue";
import ContactUs from "@/views/user/ContactUs.vue";
import privacyProvider from "@/views/user/privacyProvider.vue";
import containerRetrieve from "@/views/user/containerRetrieve.vue";
import NafathRequest from '@/views/nafath/request.vue';
import BusinessTransferUpdate from '@/views/Business_Transfer/BusinessTransferUpdate.vue';
import ChatsList from '@/views/chats/list.vue';
import MySubscription from '@/views/user/MySubscription.vue';
import PropertycreateRega from '@/views/Properties/PropertyCreateRega.vue';
import All_Properties from '@/views/Properties/All_Properties.vue';
import OwnerProperties from '@/views/Properties/OwnerProperties.vue';
import InviteFriends from '@/views/user/InviteFriends.vue';
import ParticipateWin from '@/views/user/ParticipateWin.vue';
import realEstateBulletin from '@/views/user/realEstateBulletin.vue';
import realEstateBulletinDetails from '@/views/user/realEstateBulletinDetails.vue';
import AdvertisingLicense from '@/views/user/AdvertisingLicense.vue';
import packagesList from '@/views/Subscription_Packages/packagesList.vue';
import packageDetails from '@/views/Subscription_Packages/packageDetails.vue';
import detailsMaintenance from '@/views/Subscription_Packages/detailsMaintenance.vue';
import PackagesView from '@/views/Subscription_Packages/packagesView.vue';
import PublicProfile from '@/views/profile/view.vue';
import AccountType from '@/views/profile/AccountType.vue';


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/aboutus',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/advertisements',
    name: 'AdvertisementsView',
    component: AdvertisementsView
  },
  {
    path: '/login',
    name: 'login',
    component: UserLogin
  },
  {
    path: '/register',
    name: 'register',
    component: AccountRegister
  },
  {
    path: '/profile',
    name: 'ProfilePage',
    component: ProfilePage
  },
  {
    path: '/businessproject',
    name: 'BusinessProject',
    component: BusinessProject
  },
  {
    path: '/propertie',
    name: 'propertie',
    component: PropertiePage
  },
  {
    path: '/propertydetails/:id',
    name: 'propertydetails',
    component: PropertyDetails
  },
  {
    path: '/propertypreview/:id',
    name: 'propertypreview',
    component: PropertyPerview
  },
  {
    path: '/propertiecreate',
    name: 'propertiecreate',
    component: PropertycreateRega
  },
  {
    path: '/propertymanagement',
    name: 'propertymanagement',
    component: PropertyManagement
  },
  {
    path: '/propertielist',
    name: 'propertielist',
    component: PropertieList
  },
  {
    path: '/citiesList',
    name: 'citiesList',
    component: CitiesList
  },
  {
    path: '/propertieupdate/:key',
    name: 'propertieupdate',
    component: PropertieUpdate
  },
  {
    path: '/nearproperties',
    name: 'NearProperties',
    component: NearProperties,
  },
  {
    path: '/wallet',
    name: 'WalletPage',
    component: WalletPage
  },
  {
    path: '/addpaymentcard',
    name: 'AddCard',
    component: AddCard
  },
  {
    path: '/paymentcards',
    name: 'PaymentCards',
    component: PaymentCards
  },
  {
    path: '/previewlist',
    name: 'PreviewList',
    component: PreviewList
  },
  {
    path: '/previewdetails/:id',
    name: 'PreviewDetails',
    component: PreviewDetails
  },
  {
    path: '/myreservations',
    name: 'MyReservations',
    component: MyReservations
  },
  {
    path: '/propertyreservation/:id',
    name: 'Propertyreservation',
    component: PropertyReservation
  },
  {
    path: '/propertyrequest',
    name: 'PropertyRequest',
    component: PropertyRequest
  },
  {
    path: '/questions',
    name: 'QuestionsPage',
    component: QuestionsPage
  },
  {
    path: '/favorite',
    name: 'FavoriteProperties',
    component: FavoriteProperties
  },
  {
    path: '/maintenances',
    name: 'MaintenanceRequest',
    component: MaintenanceRequest
  },
  {
    path: '/maintenancedetails/:id',
    name: 'MaintenanceDetails',
    component: MaintenanceDetails
  },
  {
    path: '/maintenance',
    name: 'MaintenancePage',
    component: MaintenancePage
  },
  {
    path: '/maps',
    name: 'MapsPage',
    component: MapsPage
  },
  {
    path: '/blog',
    name: 'BlogForm',
    component: BlogForm
  },
  {
    path: '/blogDetails/:key',
    name: 'BlogDetails',
    component: BlogDetails
  },
  {
    path: '/setting',
    name: 'SettingsPage',
    component: SettingsPage
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: ForgetPassword
  },
  {
    path: '/rental/:key',
    name: 'RentalRetrieve',
    component: RentalRetrieve
  },
  {
    path: '/terms',
    name: 'TermsConditions',
    component: TermsConditions
  },
  {
    path: '/financialtransactions',
    name: 'FinancialTransactions',
    component: FinancialTransactions
  },
  {
    path: '/payment/success',
    name: 'SuccessPage',
    component: SuccessPage
  },
  {
    path: '/payment/failed',
    name: 'FailedPage',
    component: FailedPage
  },
  {
    path: '/paymentfailed',
    name: 'PaymentFailed',
    component: PaymentFailed
  },
  {
    path: '/paymentsuccess',
    name: 'PaymentSuccess',
    component: PaymentSuccess
  },
  {
    path: '/myproperty',
    name: 'MyProperty',
    component: MyProperty
  },
  {
    path: '/myrents',
    name: 'MyRents',
    component: MyRents
  },
  {
    path: '/mybankaccount',
    name: 'MybankAccount',
    component: MybankAccount
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Page404',
    component: Page404
  },
  {
    path: '/createfinance/:key',
    name: 'CreateFinance',
    component: CreateFinance
  },
  {
    path: '/myrequests',
    name: 'MyRequests',
    component: MyRequests
  },
  {
    path: '/maintenanceslist',
    name: 'MaintenancesList',
    component: MaintenancesList
  },
  {
    path: '/photography',
    name: 'professionalPhotography',
    component: professionalPhotography
  },
  {
    path: '/photographyDetails/:id',
    name: 'photographyDetails',
    component: photographyDetails
  },
  {
    path: '/lawyer',
    name: 'lawyer',
    component: lawyerRequested
  },
  {
    path: '/lawyerRequested/:id',
    name: 'lawyerRequested',
    component: lawyerRequested
  },
  {
    path: '/businessTransferList',
    name: 'BusinessTransferList',
    component: BusinessTransferList
  },
  {
    path: '/businessTransfer/:id',
    name: 'Business_TransferDetails',
    component: Business_TransferDetails
  },
  {
    path: '/lawyerRequestedDetails/:id',
    name: 'lawyerRequestedDetails',
    component:  lawyerRequestedDetails
  },
  {
    path: '/advertismentReport',
    name: 'AdvertismentReport',
    component: AdvertismentReport
  },
  {
    path: '/propReservationDetails/:id',
    name: 'PropReservationDetails',
    component: PropReservationDetails
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/complaints',
    name: 'complaints',
    component: Complaints
  },

  {
    path: '/contactUs',
    name: 'ContactUs',
    component: ContactUs
  },

  {
    path: '/privacyProvider',
    name: 'privacyProvider',
    component: privacyProvider
  },

  {
    path: '/containerRetrieve/:id',
    name: 'containerRetrieve',
    component: containerRetrieve
  },
  {
    path: '/nafath',
    name: 'NafathRequest',
    component: NafathRequest
  },
  {
    path: '/businessTransferUpdate/:id',
    name: 'BusinessTransferUpdate',
    component: BusinessTransferUpdate
  },
  {
    path: '/chats',
    name: 'ChatsList',
    component: ChatsList
  },
  {
    path: '/mySubscription',
    name: 'MySubscription',
    component: MySubscription
  },
  {
    path: '/allProperties',
    name: 'All_Properties',
    component: All_Properties
  },
  {
    path: '/ownerProperties',
    name: 'OwnerProperties',
    component: OwnerProperties
  },
  {
    path: '/inviteFriends',
    name: 'InviteFriends',
    component: InviteFriends
  },
  {
    path: '/participateWin',
    name: 'ParticipateWin',
    component: ParticipateWin
  },
  {
    path: '/realEstateBulletin',
    name: 'realEstateBulletin',
    component: realEstateBulletin
  },
  {
    path: '/realEstateBulletinDetails',
    name: 'realEstateBulletinDetails',
    component: realEstateBulletinDetails
  },
  {
    path: '/advertisingLicense',
    name: 'advertisingLicense',
    component: AdvertisingLicense
  },
  {
    path: '/packagesList',
    name: 'packagesList',
    component: packagesList
  },
  {
    path: '/packageDetails',
    name: 'packageDetails',
    component: packageDetails
  },
  {
    path: '/detailsMaintenance',
    name: 'detailsMaintenance',
    component: detailsMaintenance
  },
  {
    path: '/detailsMaintenance/:id',
    name: 'PackagesView',
    component: PackagesView
  },
  {
    path: '/portfolio/:id',
    name: 'PublicProfile',
    component: PublicProfile
  },
  {
    path: '/accountType',
    name: 'AccountType',
    component: AccountType
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
